var SliderControls = class extends HTMLElement {
  async connectedCallback() {
    const items = this.querySelectorAll("[data-action='select']");
    items.forEach((button) => {
      button.addEventListener("click", (event) => {
        const index = event.target.dataset.mediaIndex;
        this.sliderComponent.goToSlide(index);
        this._onSlideChanged(index);
      });
    });
    this._onSlideChanged(1);

    this.bindEvent();
  }
  get sliderComponent() {
    return document.getElementById(this.getAttribute("controls"));
  }
  bindEvent() {
    const mediaGalleryNode = this.closest('media-gallery');
    if (!mediaGalleryNode) return;
    const sliderComponentNode = mediaGalleryNode.querySelector('slider-component');
    const sliderControlsNode = mediaGalleryNode.querySelector('slider-controls');
    const mediaTypeBtnNodes = mediaGalleryNode.querySelector('[media-type-btn]');
    if (!mediaTypeBtnNodes || !sliderControlsNode || !sliderComponentNode) return;

    const sliderControlsBtnNodes = sliderControlsNode.querySelectorAll('button');
    let videoIndex = null;
    let imageIndex = null;

    for (let i = 0; i < sliderControlsBtnNodes.length; i++) {
      if (videoIndex !== null && imageIndex !== null) {
        break;
      }
      const btn = sliderControlsBtnNodes[i];
      if (btn.dataset.btnType === 'image') {
        if (imageIndex === null) imageIndex = i + 1;
      } else if (btn.dataset.btnType === 'video') {
        if (videoIndex === null) videoIndex = i + 1;
      }
    }
    mediaTypeBtnNodes.addEventListener('click', (event) => {
      const mediaBtnNode = event.target.closest('[media-btn]');
      if (!mediaBtnNode) return;
      const btnType = mediaBtnNode.getAttribute('type');
      if (btnType === 'image') {
        sliderComponentNode.goToSlide(imageIndex);
      } else if (btnType === 'video') {
        sliderComponentNode.goToSlide(videoIndex);
      }
    });
  }
  async _onSlideChanged(active, animate = true) {
    const items = this.querySelectorAll("[data-action='select']");
    const activeItem = items[active - 1];
    items.forEach((items, idx) => {
      items.setAttribute("aria-current", "false");
    });

    activeItem.setAttribute("aria-current", "true");

    this.setMediaTypeOption(activeItem);

    requestAnimationFrame(() => {
      if (activeItem.offsetParent && activeItem.offsetParent !== this) {
        const windowHalfHeight = this.clientHeight / 2,
          windowHalfWidth = this.clientWidth / 2;
        this.scrollTo({
          behavior: animate ? "smooth" : "auto",
          top:
            activeItem.offsetTop -
            windowHalfHeight +
            activeItem.clientHeight / 2,
          left:
            activeItem.offsetLeft -
            windowHalfWidth +
            activeItem.clientWidth / 2,
        });
      }
    });
  }

  setMediaTypeOption(activeItem) {
    try {
      const btnType = activeItem.dataset.btnType;
      // const btnType = 'video';
      const mediaGallery = this.closest('media-gallery');
      if (!mediaGallery) return;
      const mediaOptionNode = mediaGallery.querySelector('.media-type-option');
      if (!mediaOptionNode) return;
      const optionTypeBtnNodes = mediaOptionNode.querySelectorAll('.option-type-btn');
      optionTypeBtnNodes.forEach((item) => {
        item.classList.remove('active');
      });
      if (btnType === 'image') {
        mediaOptionNode.querySelector('.option-type-btn-image').classList.add('active');
        return;
      }
      if (btnType === 'video') {
        mediaOptionNode.querySelector('.option-type-btn-video').classList.add('active');
        return;
      }
    } catch (error) {
      console.log('setMediaTypeOption', error);
    }
  }
};
window.customElements.define("slider-controls", SliderControls);
